import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CHANNEL } from 'constants/ChatConstants';
import { CAMPAIGN_MANAGER, LEADERSHIP_ROLES } from 'constants/UserConstants';

export const DETAILS_SOURCE = 'campaigns-details';
export const DASHBOARD_SOURCE = 'campaigns-dashboard';
export const CREATION_MODAL_SOURCE = 'campaigns-modal-creation';
export const DUPLICATE_MODAL_SOURCE = 'campaigns-modal-duplicate';
export const BULK_CREATION_MODAL_SOURCE = 'campaigns-modal-creation-bulk';

export const CAMPAIGN_STATUS_ENUM = {
  DRAFT: 'DRAFT',
  PLANNED: 'PLANNED',
  SENDING: 'SENDING',
  ERROR: 'ERROR',
  STOPPED: 'STOPPED',
  SENT: 'SENT',
  CLOSED: 'CLOSED',
};

export const TRIGGERED_CAMPAIGN_STATUSES = [
  CAMPAIGN_STATUS_ENUM.CLOSED,
  CAMPAIGN_STATUS_ENUM.ERROR,
  CAMPAIGN_STATUS_ENUM.SENDING,
  CAMPAIGN_STATUS_ENUM.SENT,
  CAMPAIGN_STATUS_ENUM.STOPPED,
];

export const DEFAULT_STATUS = [
  CAMPAIGN_STATUS_ENUM.DRAFT,
  CAMPAIGN_STATUS_ENUM.PLANNED,
  CAMPAIGN_STATUS_ENUM.ERROR,
  CAMPAIGN_STATUS_ENUM.SENDING,
  CAMPAIGN_STATUS_ENUM.SENT,
  CAMPAIGN_STATUS_ENUM.STOPPED,
];

export const CAMPAIGN_STATUS_LABEL = {
  [CAMPAIGN_STATUS_ENUM.CLOSED]: <FormattedMessage id="intervention_status.closed" defaultMessage="Closed" />,
  [CAMPAIGN_STATUS_ENUM.DRAFT]: <FormattedMessage id="audito.audit_status.draft" defaultMessage="Draft" />,
  [CAMPAIGN_STATUS_ENUM.PLANNED]: (
    <FormattedMessage id="customSteps.fixedStep.description.planned" defaultMessage="Planned" />
  ),
  [CAMPAIGN_STATUS_ENUM.SENDING]: (
    <FormattedMessage id="page.fiche.reminder.enableAutoSend.title" defaultMessage="Sending" />
  ),
  [CAMPAIGN_STATUS_ENUM.SENT]: (
    <FormattedMessage id="intervention_status.sent" defaultMessage="Sent" />
  ),
  [CAMPAIGN_STATUS_ENUM.STOPPED]: <FormattedMessage id="page.campaigns.status.stopped" defaultMessage="Stopped" />,
  [CAMPAIGN_STATUS_ENUM.ERROR]: <FormattedMessage id="error.label" defaultMessage="Error" />,
};

export const DATA_FIELD = {
  [CHANNEL.EMAIL]: 'emails',
  [CHANNEL.SMS]: 'phoneNumbers'
};

export const ALLOWED_CREATION_ROLES = [...LEADERSHIP_ROLES, CAMPAIGN_MANAGER];

export const TOTAL_COLUMN_NAME = 'numberSent';

export const CAMPAIGN_EVENT_TYPE_ENUM = {
  BULK_INTERVENTIONS_CREATED_COMPLETED: 'BULK_INTERVENTIONS_CREATED_COMPLETED',
  BULK_FOLLOW_COMPLETED: 'BULK_FOLLOW_COMPLETED',
  BULK_UNFOLLOW_COMPLETED: 'BULK_UNFOLLOW_COMPLETED',
  CLOSED: 'CLOSED',
  CREATED: 'CREATED',
  DELETED: 'DELETED',
  DUPLICATED: 'DUPLICATED',
  SCHEDULED: 'SCHEDULED',
  SCHEDULE_CANCELLED: 'SCHEDULE_CANCELLED',
  SENT: 'SENT',
  SENDING_APPROVED: 'SENDING_APPROVED',
  SENDING_STOPPED: 'SENDING_STOPPED',
  STATS_UPDATE: 'STATS_UPDATE',
  UNSUBSCRIBED: 'UNSUBSCRIBED',
  UPDATED: 'UPDATED',
};
